import {Logo} from "../specific/Logo.tsx";
import {Link} from "react-router-dom";

export function Header({disableX = false}: { disableX?: boolean } = {}) {
    return <header className="mx-auto mt-8 max-w-1xl px-4 lg:max-w-7xl lg:px-8 flex justify-between items-center">
        <div>
            <Logo/>
        </div>
        <div>
            {!disableX && <Link to={'/'}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                     stroke="currentColor" className="size-8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12"/>
                </svg>
            </Link>}

        </div>
    </header>;
}
